import { render } from "./projectStatusDetail.vue?vue&type=template&id=7228aab0&ts=true"
import script from "./projectStatusDetail.vue?vue&type=script&lang=ts"
export * from "./projectStatusDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__